module.exports = __webpack_public_path__ + "static/media/cc_icon-nyce.19a7359f.svg";